import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { UserService } from '../user/user.service';
import { UserModel } from '../user/user.model';
import { Router } from '@angular/router';
import { SupportTicketsComponent } from './tickets.component';
import { SupportTicketsService } from './tickets.service';
import { DummyComponent } from '../../shared/dummy.component';
import { SupportTicketsModel } from './tickets.model';
import { SupportTicketsResponsesModel } from './ticketsResponses.model';


@Component({
    selector: 'app-supportticketsconversation',
    templateUrl: './tickets-conversation.component.html',
    styleUrls: ['./tickets.component.css'],
    standalone: false
})

export class SupportTicketsConversationComponent implements OnInit {

    user: UserModel;
    isAdmin: boolean = false;
    ticket: SupportTicketsModel = new SupportTicketsModel();
    ticketId: number = this.data.ticketId;
    listTicketResponses: SupportTicketsResponsesModel[] = [];
    ticketResponse: SupportTicketsResponsesModel = new SupportTicketsResponsesModel();
    enable: boolean = false;
    ready: boolean = false;
    saving: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<SupportTicketsComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public snackBar: MatSnackBar,
        public dialog: MatDialog,
        public supportTicketService: SupportTicketsService,
        public userService: UserService,
        public dummy: DummyComponent,
        private router: Router,
    ) { }

    resolveTicket() {
        this.supportTicketService.resolveTicket(this.ticketId).then(response => {
            this.dummy.redirectTo(this.router.url);
            this.closeDialog();
        })
    }

    enableResponse() {
        if (this.enable) { this.enable = false } else { this.enable = true; }
    }

    save = function () {
        this.saving = true;
        this.enable = false;
        this.ticketResponse.ticketId = this.ticket.id;
        this.ticketResponse.Name = this.user.username;
        this.ticketResponse.OwnerUid = this.user.uid;
        this.supportTicketService.addTicketResponse(this.ticketResponse)
            .then(response => {
                this.ticketResponse = response;
                this.dummy.redirectTo(this.router.url);
                this.closeDialog();
                this.saving = false;
            })
    }

    ngOnInit() {
        this.userService.loadData().then(userData => {
            this.user = userData;
            this.isAdmin = this.user.isAdmin;
            this.supportTicketService.getTicket(this.ticketId).then(response => this.ticket = response);
            this.supportTicketService.getListTicketResponses(this.ticketId).then(response => {
                this.listTicketResponses = response;
            })
            this.ready = true;
        })
    }

    closeDialog() {
        this.dialogRef.close();
    }

  public trackByIndex(i: number) { return i; }

}